import axios from 'axios'
import { useAuthStore } from '../stores/authStore.js'

const api = axios.create({
  baseURL: '/api/v1',
  headers: {
    'Content-Type': 'application/json'
  }
})

api.interceptors.request.use(
  (config) => {
    const { token } = useAuthStore.getState()
    // Fallback to localStorage if state is empty
    let authToken = token
    if (!authToken) {
      try {
        const stored = localStorage.getItem('auth_data')
        if (stored) {
          const parsed = JSON.parse(stored)
          authToken = parsed.token
        }
      } catch (e) {
        // ignore
      }
    }
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      const { logout } = useAuthStore.getState()
      logout()
      // Also clear localStorage
      try {
        localStorage.removeItem('auth_data')
      } catch (e) {
        // ignore
      }
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default api
